import { Participant, ParticipantKind } from 'livekit-client';
import toArray from 'lodash/toArray';

export const getMonogramFromName = (name: string) =>
    name
        .split(' ')
        .map((namePart) => toArray(namePart)[0])
        .slice(0, 2)
        .join('')
        .toLocaleUpperCase();

export const checkIsAgent = ({ kind }: Participant) => kind === ParticipantKind.AGENT;

export const filterRemoteParticipants = <T extends Participant>(
    participants: Map<string, T>,
    filter: (participant: T) => boolean,
) => {
    const filteredParticipants = new Map(participants);
    Array.from(filteredParticipants.values()).forEach((participant: T) => {
        if (filter(participant)) {
            filteredParticipants.delete(participant.identity);
        }
    });

    return filteredParticipants;
};

export const excludeAgents = <T extends Participant>(participants: Map<string, T>) =>
    filterRemoteParticipants(participants, checkIsAgent);
